<template>
  <DragPanel
    title="纹理动画"
    :closePanel="closePanel"
    :tooltipVisible="false"
    class="common-drag-panel"
  >
    <div class="common-tree-box">
      <el-tree
        class="dialog-tree-small-primary"
        ref="textureTree"
        :data="textureData"
        :props="defaultProps"
        node-key="nodeId"
        highlight-current
        default-expand-all
        :expand-on-click-node="false"
        @node-click="handleNodeClick"
      >
        <div slot-scope="{ data }" class="custom-node-box">
          <div class="node-content-box">
            <div class="text-overflow dialog-label" :title="data.nodeName">
              {{ data.nodeName }}
            </div>
            <div v-if="data.isDataSet" class="custom-button-box">
              <el-button
                type="text"
                size="small"
                @click="(e) => batchToggleViewTexture(data, e)"
                :title="`${batchView ? '批量隐藏' : '批量显示'}`"
              >
                <icon-svg
                  v-if="batchView"
                  icon-class="ic-xianshi1"
                  class="icon"
                />
                <icon-svg v-else icon-class="ic-a-yincang1" class="icon" />
              </el-button>
              <el-button
                type="text"
                size="small"
                @click="(e) => batchStop(data, e)"
                :title="`${batchPaly ? '批量停止' : '批量播放'}`"
              >
                <icon-svg
                  v-if="batchPaly"
                  icon-class="ic-bofang1"
                  class="icon"
                />
                <icon-svg v-else icon-class="ic-zanting1" class="icon" />
              </el-button>
            </div>
            <div v-show="data.isPath" class="custom-button-box">
              <el-button
                type="text"
                size="small"
                @click="(e) => toggleViewTexture(data, e)"
                :title="`${data.isView ? '隐藏' : '显示'}`"
              >
                <icon-svg
                  v-if="data.isView"
                  icon-class="ic-xianshi1"
                  class="icon"
                />
                <icon-svg v-else icon-class="ic-a-yincang1" class="icon" />
              </el-button>
              <el-button
                type="text"
                size="small"
                @click="(e) => stopUVAnim(data, e)"
                :title="`${data.isPlay ? '停止' : '播放'}`"
              >
                <icon-svg
                  v-if="data.isPlay"
                  icon-class="ic-bofang1"
                  class="icon"
                />
                <icon-svg v-else icon-class="ic-zanting1" class="icon" />
              </el-button>
            </div>
          </div>
        </div>
      </el-tree>
    </div>
  </DragPanel>
</template>

<script>
import DragPanel from "@/components/CustomDragPanel.vue";

import { getTextureList } from "@/service/interface";
export default {
  data() {
    return {
      batchView: true,
      batchPaly: true,
      textureData: [],
      defaultProps: {
        children: "subNodes",
        label: "nodeName",
      },
    };
  },
  props: {
    dataSet: Object,
    closePanel: Function,
  },
  components: {
    DragPanel,
  },
  mounted() {
    this.initTextureData();
  },
  watch: {
    dataSet: function (newVal, oldVal) {
      if (newVal.dataSetId !== oldVal.dataSetId) {
        this.initTextureData();
      }
    },
  },
  methods: {
    initTextureData() {
      let dataSetId = this.dataSet.dataSetId;
      getTextureList({ dataSetId }).then((response) => {
        if (response.isSuccess) {
          let data = response.data;
          data = this.formatData(data);
          let textureData = [
            {
              isDataSet: true,
              dataSetId: this.dataSet.dataSetId,
              nodeId: this.dataSet.nodeId,
              nodeName: this.dataSet.nodeName,
              subNodes: data,
            },
          ];
          this.textureData = textureData;
        } else {
          this.$message.error(response.errMsg);
        }
      });
    },
    handleNodeClick(nodeData) {
      if (nodeData.isPath) {
        let Camera = window.BlackHole3D.Camera;
        let dataSetId = nodeData.dataSetId;
        dataSetId = dataSetId.replaceAll("-", "");
        let locIDList = [{ dataSetId, elemIdList: nodeData.elements }];
        Camera.setCamLocateToElem(locIDList, 1.0);
      }
    },
    batchToggleViewTexture(nodeData, e) {
      e && e.stopPropagation();

      let paths = nodeData.subNodes;
      const BlackHole3D = window.BlackHole3D;
      paths.forEach((item) => {
        let dataSetId = item.dataSetId;
        dataSetId = dataSetId.replaceAll("-", "");

        let anim = new BlackHole3D.REElemUVAnim();
        anim.dataSetId = dataSetId;
        anim.elemIdList = item.elements;

        if (this.batchView) {
          anim.scale = [0, 0];
          anim.speed = [0.0, 0.0];
        } else {
          let scale = Number((1 / item.compressionRatio).toFixed(2));
          anim.scale = [scale, 1];
          if (item.isPlay) {
            let speed = item.direction > 0 ? item.flowRate : -item.flowRate;
            anim.speed = [speed, 0];
          }
        }
        BlackHole3D.BIM.setElemUVAnimAttr(anim);

        item.isView = !this.batchView;
      });

      this.batchView = !this.batchView;
    },
    toggleViewTexture(nodeData, e) {
      e.stopPropagation();
      const BlackHole3D = window.BlackHole3D;
      let dataSetId = nodeData.dataSetId;
      dataSetId = dataSetId.replaceAll("-", "");

      let anim = new BlackHole3D.REElemUVAnim();
      anim.dataSetId = dataSetId;
      anim.elemIdList = nodeData.elements;
      if (nodeData.isView) {
        anim.scale = [0, 0];
        anim.speed = [0.0, 0.0];
      } else {
        let scale = Number((1 / nodeData.compressionRatio).toFixed(2));
        anim.scale = [scale, 1];
        if (nodeData.isPlay) {
          let speed =
            nodeData.direction > 0 ? nodeData.flowRate : -nodeData.flowRate;
          anim.speed = [speed, 0];
        }
      }
      BlackHole3D.BIM.setElemUVAnimAttr(anim);

      nodeData.isView = !nodeData.isView;

      let textureData = this.textureData[0].subNodes;
      this.batchView = textureData.some((el) => el.isView);
    },
    batchStop(nodeData, e) {
      e.stopPropagation();

      let paths = nodeData.subNodes;
      const BlackHole3D = window.BlackHole3D;
      paths.forEach((item) => {
        let dataSetId = item.dataSetId;
        dataSetId = dataSetId.replaceAll("-", "");

        let anim = new BlackHole3D.REElemUVAnim();
        anim.dataSetId = dataSetId;
        anim.elemIdList = item.elements;
        let scale = Number((1 / item.compressionRatio).toFixed(2));
        anim.scale = [scale, 1];

        if (this.batchPaly) {
          anim.speed = [0.0, 0.0];
        } else {
          let speed = item.direction > 0 ? item.flowRate : -item.flowRate;
          anim.speed = [speed, 0];
        }

        BlackHole3D.BIM.setElemUVAnimAttr(anim);

        item.isPlay = !this.batchPaly;
      });

      this.batchPaly = !this.batchPaly;
    },
    stopUVAnim(nodeData, e) {
      e.stopPropagation();

      let dataSetId = nodeData.dataSetId;
      dataSetId = dataSetId.replaceAll("-", "");

      const BlackHole3D = window.BlackHole3D;
      let anim = new BlackHole3D.REElemUVAnim();
      anim.dataSetId = dataSetId;
      anim.elemIdList = nodeData.elements;
      let scale = Number((1 / nodeData.compressionRatio).toFixed(2));
      anim.scale = [scale, 1];
      if (nodeData.isPlay) {
        anim.speed = [0.0, 0.0];
      } else {
        let speed =
          nodeData.direction > 0 ? nodeData.flowRate : -nodeData.flowRate;
        anim.speed = [speed, 0];
      }

      nodeData.isPlay = !nodeData.isPlay;

      BlackHole3D.BIM.setElemUVAnimAttr(anim);

      let textureData = this.textureData[0].subNodes;
      this.batchPaly = textureData.some((el) => el.isPlay);
    },
    formatData(data) {
      data.forEach((item) => {
        item.nodeName = item.name;
        item.subNodes = [];
        item.isPath = true;
        item.isPlay = true;
        item.isView = true;
      });
      return data;
    },
  },
};
</script>

<style lang="less" scoped>
@import "@/assets/css/publishSearch.less";
.common-drag-panel {
  top: 214px;
  right: 20px;
  width: 360px;
  height: calc(100% - 225px);
  min-width: 320px;
  min-height: 300px;

  /deep/ .content {
    height: calc(100% - 45px);
    .common-tree-box {
      height: 100%;
      padding: 5px 10px;
      .custom-node-box {
        width: 100%;

        .node-content-box {
          display: flex;
          justify-content: space-between;
          height: 24px;
          align-items: center;

          .custom-button-box {
            margin: 0px 5px;
            .el-button {
              margin-right: 0px;
            }

            .icon {
              font-size: 14px;
              color: var(--default-color);
            }
          }
        }
      }
    }
  }
}
</style>